import { render, staticRenderFns } from "./catDetails.vue?vue&type=template&id=3576563e&scoped=true&"
import script from "./catDetails.vue?vue&type=script&lang=js&"
export * from "./catDetails.vue?vue&type=script&lang=js&"
import style0 from "./catDetails.vue?vue&type=style&index=0&id=3576563e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3576563e",
  null
  
)

export default component.exports